module.exports = __webpack_public_path__ + "static/17week-d5b7b6dfe0f90e829ebaee27cbfe2b09.png";